import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/game/animal.png';
import _imports_1 from '@/assets/images/game/inletBtn.png';
import _imports_2 from '@/assets/images/game/build.png';
import _imports_3 from '@/assets/images/game/gameicon.png';
import _imports_4 from '@/assets/images/game/windowTitle.png';
import _imports_5 from '@/assets/images/game/close.png';
const _withScopeId = n => (_pushScopeId("data-v-1c50da90"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "animalBox"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "animal",
  src: _imports_0,
  alt: "animal",
  draggable: "false"
})], -1));
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img class=\"build\" src=\"" + _imports_2 + "\" alt=\"build\" draggable=\"false\" data-v-1c50da90><div class=\"intro\" data-v-1c50da90><div class=\"introtitle\" data-v-1c50da90><img class=\"gameicon\" src=\"" + _imports_3 + "\" alt=\"gameicon\" draggable=\"false\" data-v-1c50da90><span data-v-1c50da90>Hello!Al@K12</span></div><p class=\"introtext1\" data-v-1c50da90>面向青少年AI素养培育的在线交互系统</p><p class=\"introtext2\" data-v-1c50da90>Hello!Al@K12旨在通过游戏方式了解AI任务，学习AI算法，帮助青少年理解和掌握人工智能的基本概念和原理。</p></div>", 2);
const _hoisted_4 = {
  class: "mask"
};
const _hoisted_5 = {
  class: "popup-container"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "title",
  draggable: "false"
}, null, -1));
import { reactive, ref } from "vue";
import principalSheet from './principalSheet.vue';
import GameHeader from "./components/GameHeader.vue";
import level from "./level.vue";
import answer from "./answer.vue";
export default {
  __name: 'Index',
  setup(__props) {
    const showPopup = ref(false);
    const showPage = ref(1);
    const arrangeNum = ref(null);
    const goldCoin = ref(200);
    const levelChange = ref(0);
    const smallLevelIndex = ref(undefined);
    const groupListName = ref('');
    const handleSheet = reactive({
      fn: (data, val, index) => {
        if (index === undefined) {
          arrangeNum.value = val;
          showPage.value = data;
          return;
        }
        smallLevelIndex.value = index;
        showPage.value = data;
        groupListName.value = val;
      }
    });
    const handleBack = reactive({
      fn: () => {
        showPage.value = showPage.value - 1;
        levelChange.value = levelChange.value + 1;
      }
    });
    const handleGoHome = reactive({
      fn: () => {
        const list = JSON.parse(localStorage.getItem('levelList'));
        const levelList = localStorage.getItem('levelListIndex');
        list[levelList].current = list[levelList].current === 11 ? list[levelList].current : Number(localStorage.getItem('groupListIndex')) + 1;
        localStorage.setItem('levelList', JSON.stringify(list));
        levelChange.value = levelChange.value + 1;
        showPage.value = 1;
        // levelChange.value = levelChange.value + 1
      }
    });

    const setGoldCoin = reactive({
      fn: val => {
        // goldCoin.value = goldCoin.value + 50
        if (val) {
          goldCoin.value = 200;
          return;
        }
        goldCoin.value = Number(localStorage.getItem('goldCoin'));
      }
    });
    const getLevel = reactive({
      fn: () => {
        levelChange.value = levelChange.value + 1;
      }
    });
    function handlePopup() {
      showPopup.value = !showPopup.value;
      showPage.value = 1;
      // if (showPopup.value === true) {
      //   stop()
      //   return
      // }
      // move()
    }

    function handleClose() {
      showPopup.value = !showPopup.value;
    }

    // 滑动限制
    function stop() {
      const mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = 'hidden';
      document.addEventListener("touchmove", mo, false); // 禁止页面滑动
    }

    // 取消滑动限制
    function move() {
      const mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ''; // 出现滚动条
      document.removeEventListener("touchmove", mo, false);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "vessel",
        onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, [_createElementVNode("div", {
        class: "casket"
      }, [_createElementVNode("div", {
        class: "inlet"
      }, [_hoisted_1, _createElementVNode("img", {
        class: "inletBtn",
        onClick: handlePopup,
        src: _imports_1,
        alt: "inletBtn",
        draggable: "false"
      })]), _hoisted_2]), _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [[_vShow, showPopup.value]]), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "popup-window"
      }, [_hoisted_6, _createElementVNode("img", {
        onClick: handleClose,
        src: _imports_5,
        alt: "close",
        draggable: "false"
      })]), _createElementVNode("div", {
        class: _normalizeClass(["popup", [showPage.value === 1 && arrangeNum.value === 0 ? 'index' : 'index', showPage.value === 2 && arrangeNum.value === 0 ? 'arrangeColor-0' : showPage.value === 2 && arrangeNum.value === 1 ? 'arrangeColor-1' : showPage.value === 2 && arrangeNum.value === 2 ? 'arrangeColor-2' : showPage.value === 2 && arrangeNum.value === 3 ? 'arrangeColor-3' : '', showPage.value === 3 && arrangeNum.value === 0 ? 'arrangeColorBg-0' : showPage.value === 3 && arrangeNum.value === 1 ? 'arrangeColorBg-1' : showPage.value === 3 && arrangeNum.value === 2 ? 'arrangeColorBg-2' : showPage.value === 3 && arrangeNum.value === 3 ? 'arrangeColorBg-3' : '']])
      }, [_createVNode(GameHeader, {
        headShow: showPage.value === 1,
        arrangeNum: arrangeNum.value,
        turnBack: handleBack.fn,
        goldCoin: goldCoin.value
      }, null, 8, ["headShow", "arrangeNum", "turnBack", "goldCoin"]), _withDirectives(_createVNode(principalSheet, {
        handleSheetClick: handleSheet.fn,
        levelChange: levelChange.value,
        setGoldCoin: setGoldCoin.fn
      }, null, 8, ["handleSheetClick", "levelChange", "setGoldCoin"]), [[_vShow, showPage.value === 1]]), _withDirectives(_createVNode(level, {
        arrangeNum: arrangeNum.value,
        handleSheetClick: handleSheet.fn,
        levelChange: levelChange.value
      }, null, 8, ["arrangeNum", "handleSheetClick", "levelChange"]), [[_vShow, showPage.value === 2]]), showPage.value === 3 ? (_openBlock(), _createBlock(answer, {
        key: 0,
        arrangeNum: arrangeNum.value,
        smallLevelIndex: smallLevelIndex.value,
        handleGoHome: handleGoHome.fn,
        setGoldCoin: setGoldCoin.fn,
        getLevel: getLevel.fn,
        groupListName: groupListName.value
      }, null, 8, ["arrangeNum", "smallLevelIndex", "handleGoHome", "setGoldCoin", "getLevel", "groupListName"])) : _createCommentVNode("", true)], 2)], 512), [[_vShow, showPopup.value]])], 32);
    };
  }
};